import React from "react"
import PropTypes from "prop-types"

const Sync = ({ color }) => {
  return (
    <svg
      version="1.1"
      role="img"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      width="18px"
      height="20px"
      viewBox="0 0 18 20"
    >
      <path xmlns="http://www.w3.org/2000/svg" d="M2.99902 16.7V19C2.99902 19.2652 2.89367 19.5196 2.70613 19.7071C2.51859 19.8946 2.26424 20 1.99902 20C1.73381 20 1.47945 19.8946 1.29192 19.7071C1.10438 19.5196 0.999023 19.2652 0.999023 19V14C0.999023 13.7348 1.10438 13.4804 1.29192 13.2929C1.47945 13.1054 1.73381 13 1.99902 13H6.99902C7.26424 13 7.51859 13.1054 7.70613 13.2929C7.89367 13.4804 7.99902 13.7348 7.99902 14C7.99902 14.2652 7.89367 14.5196 7.70613 14.7071C7.51859 14.8946 7.26424 15 6.99902 15H4.09902C5.08354 15.965 6.33108 16.6178 7.68517 16.8766C9.03926 17.1353 10.4396 16.9885 11.7106 16.4545C12.9815 15.9205 14.0665 15.0231 14.8294 13.8748C15.5923 12.7266 15.9992 11.3786 15.999 10C15.999 9.73478 16.1044 9.48043 16.2919 9.29289C16.4795 9.10536 16.7338 9 16.999 9C17.2642 9 17.5186 9.10536 17.7061 9.29289C17.8937 9.48043 17.999 9.73478 17.999 10C17.9974 11.7367 17.4934 13.4358 16.5478 14.8925C15.6021 16.3491 14.2552 17.501 12.6695 18.2093C11.0838 18.9176 9.32708 19.152 7.61116 18.8841C5.89525 18.6163 4.29347 17.8578 2.99902 16.7ZM14.999 3.3V1C14.999 0.734784 15.1044 0.48043 15.2919 0.292893C15.4795 0.105357 15.7338 0 15.999 0C16.2642 0 16.5186 0.105357 16.7061 0.292893C16.8937 0.48043 16.999 0.734784 16.999 1V6C16.999 6.26522 16.8937 6.51957 16.7061 6.70711C16.5186 6.89464 16.2642 7 15.999 7H10.999C10.7338 7 10.4795 6.89464 10.2919 6.70711C10.1044 6.51957 9.99902 6.26522 9.99902 6C9.99902 5.73478 10.1044 5.48043 10.2919 5.29289C10.4795 5.10536 10.7338 5 10.999 5H13.899C12.9145 4.03499 11.667 3.38216 10.3129 3.12341C8.95879 2.86465 7.55844 3.01149 6.28747 3.54551C5.01651 4.07953 3.93153 4.97695 3.16862 6.1252C2.4057 7.27345 1.99883 8.62141 1.99902 10C1.99902 10.2652 1.89367 10.5196 1.70613 10.7071C1.51859 10.8946 1.26424 11 0.999023 11C0.733807 11 0.479453 10.8946 0.291917 10.7071C0.10438 10.5196 -0.000976562 10.2652 -0.000976562 10C0.000605864 8.26332 0.504622 6.56418 1.45028 5.10754C2.39593 3.65089 3.74284 2.49896 5.32853 1.79069C6.91422 1.08241 8.67097 0.848045 10.3869 1.11585C12.1028 1.38366 13.7046 2.14221 14.999 3.3Z" fill={color}/>
    </svg>
  )
}

Sync.propTypes = {
  color: PropTypes.string,
}

Sync.defaultProps = {
  color: "#000000",
}

export default Sync
